import React from 'react';

const EmptyShoppingList = (props) => {

    const boxStyle = {
        width: "100%",
        height: "200px",
        border: "4px dashed #CCC",
        display: "flex",
        marginBottom: "8px"
    }
    
    return (
        <div className="text-center" style={boxStyle}>
            <div style={{margin: "auto"}}>
                <h5>No items have been added yet. Items you 'claim' on other gift lists will appear here.</h5>
            </div>
        </div>);
}
export default EmptyShoppingList;